import Papa from 'papaparse';
import Joi from 'joi';

const LINKS_SCHEMA = Joi.object({
    'A': Joi.string()
        .allow(null),
    'B': Joi.string()
        .allow(null),
    'C': Joi.number(),
    "Vehículos": Joi.number(),
    'Incentivos': Joi.number(),
    'Público': Joi.number(),
    'Privado ': Joi.number(),
    'Cooperación': Joi.number(),
    "Definiciones": Joi.string()
        .allow(null)
});

const GROUPS_SCHEMA = Joi.object({
    "Ítems": Joi.string()
        .allow(null),
    "Agrupación": Joi.string()
        .allow(null),
    "Nombre Corto": Joi.string()
        .allow(null),
    "Tooltip": Joi.number(),
});

const ADDONS_SCHEMA = Joi.object({
    "Agregaciones": Joi.string(),
    "Definiciones": Joi.string()
});

function validateCSVrows(rows, schema){
    const errors = [];

    rows.forEach((row, index) => {
        const { error, value } = schema.validate(row);
        if(error){
            errors.push({
                rowNumber: index,
                error: error,
                row: row
            });
        }
    });
    return {
        errors, 
        valid: errors.length === 0
    };
}

function validateCsvFile (file, fileType) {
    return new Promise((resolve, reject)=>{

        Papa.parse(file,  {
            header: true,
            dynamicTyping: true,
            complete: (results) => {
                let schema;
                if(fileType === 'links'){
                    schema = LINKS_SCHEMA;
                }
                else if(fileType === 'groups'){
                    schema = GROUPS_SCHEMA;
                }
                else if(fileType === 'addons'){
                    schema = ADDONS_SCHEMA;
                }else{
                    return reject('Not supported csv');
                }

                const { errors, valid } = validateCSVrows(results.data, schema);
                if(valid){
                    return resolve(true);
                }else{
                    return reject(errors);
                }
            },
            error: function(err, file, inputElem, reason)
            {
                return reject([err]);
            },
        });
        
    });
}

export {
    validateCsvFile
}